import { Message } from 'element-ui'
/**
 * Use meta.role to determine if the current user has permission
 * @param roles 用户拥有的权限数组
 * @param route 单个路由
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}

/**
 * Use meta.role to determine if the current user has permission
 * @param route 当前路由
 * @param username 用户名
 */
function isInBackList(route, username) {
  if (route.meta && route.meta.blackLists) {
    return route.meta.blackLists.includes(username)
  } else {
    return false
  }
}


/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []
  let username = JSON.parse(localStorage.getItem('flo_username'))
  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp) && !isInBackList(tmp, username)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })

  return res
}

/**
 * Filter asynchronous routing tables by recursion
 * @param fn 需要防抖的函数内容
 * @param interval 间隔时间
 */
export function debounce(fn, interval = 300) {
  let timeout = null;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      fn.apply(this, arguments);
    }, interval);
  };
}

/**
 * Filter asynchronous routing tables by recursion
 * @param fn 需要节流的函数内容
 * @param interval 间隔时间
 */
export function throttle(fn, interval = 300) {
  let canRun = true;
  return function () {
    if (!canRun) return;
    canRun = false;
    setTimeout(() => {
      fn.apply(this, arguments);
      canRun = true;
    }, interval);
  };
}


/**
 * 创建唯一的字符串
 * @return {string} ojgdvbvaua40
 */
export function createUniqueString() {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}

/**
 * 数字存储大小格式化
 * @param {number} num 存储大小 单位：Byte
 * @param {number} digits 保留几位小数
 * @return {string} 2MB
 */
export function toStorage(num, digits) {
  digits = digits || 2
  if (num < 1024) {
    return num + 'B'
  }
  num = (num * 1000 / 1024)
  const si = [
    { value: 1E18, symbol: 'E' },
    { value: 1E15, symbol: 'P' },
    { value: 1E12, symbol: 'T' },
    { value: 1E9, symbol: 'G' },
    { value: 1E6, symbol: 'M' },
    { value: 1E3, symbol: 'K' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') +
        si[i].symbol + 'B'
    }
  }
}

/**
 * 图片上传
 * @param {file} file el-upload文件对象
 * @param {number} size 限制的文件大小(kb) 默认10M
 */
export function validImgUpload(file, size) {
  size = +size || 10240
  const isSizeOut = file.size / 1024 > size
  if (isSizeOut) {
    Message.error('上传图片大小不能超过' + toStorage(size * 1024))
  }
  return !isSizeOut
}

/**
 * 数组对象排序
 */
export function compare(prop) {
  return function (obj1, obj2) {
    var val1 = Number(obj1[prop]);
    var val2 = Number(obj2[prop]);
    if (val1 < val2) {
      return -1;
    } else if (val1 > val2) {
      return 1;
    } else {
      return 0;
    }
  }
}

/**
 * 数组对象排序,由小到大
 */
export function compareReverse(prop) {
  return function (obj1, obj2) {
    var val1 = Number(obj1[prop]);
    var val2 = Number(obj2[prop]);
    if (val1 > val2) {
      return -1;
    } else if (val1 > val2) {
      return 1;
    } else {
      return 0;
    }
  }
}


/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

/**
* @param num 需要转换成千位分隔符显示的数值
*/
export function numFormat(num) {
  var res = num.toString().replace(/\d+/, function (n) { // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
      return $1 + ",";
    });
  })
  return res;
}


//颜色对象
export function randomRgbaColorGroup() {
  let r = Math.floor(Math.random() * 255);
  let g = Math.floor(Math.random() * 255);
  let b = Math.floor(Math.random() * 255);
  let group = []
  for (let i = 0; i <= 10; i++) {
    group.push(`rgba(${r},${g},${b},${i / 10})`)
  }
  return group
}

/**
 * 获取排序中文名称
 * @param {String} name 
 */
export function getOrderNameCn(name=""){
  switch (name) {
    case "descending":
      return "倒序";
      break;
    case "ascending":
      return "正序";
      break;
    default:
      return "";
      break;
  }
}

/**
 * 获取用于识别后端的简写参数
 * @param {String} type 
 */
export function getOrderType(type=""){
  switch (type) {
    case "descending":
      return "DESC";
      break;
    case "ascending":
      return "ASC";
      break;
    default:
      return "";
      break;
  }
}


